import logIt from '../../logIt';
import BaseClass from '../core/BaseClass';
import WidgetTypes from '../core/enums/WidgetTypes';

export default class PokeMessageModel extends BaseClass {
    constructor(options) {
        super(options);
        const me = this;
        me.widget = WidgetTypes.PokeMessagesOverLay;
        me.overLayModel = options.overLayModel;
        logIt('PokeMessageModel init');
        me.PokeMessages = [];
    }

    addPokeMessage(message) {
        const me = this;
        me.PokeMessages.push(message);
    }

    getPokeMessages() {
        const me = this;
        return me.PokeMessages;
    }
}
